import React, { FC, useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import { useEnvironment } from '../context/Environment/EnvironmentContext';
import configureWorker from './browser';

export const mockEnabledEnvironments = ['devtest', 'local'];

const MockHandler: FC = ({ children }) => {
  const environmentVariables = useEnvironment();
  const [serviceWorkerReady, setServiceWorkerReady] = useState(false);
  const mocksEnabled = mockEnabledEnvironments.includes(environmentVariables.ENVIRONMENT_NAME);

  useEffect(() => {
    const handleMockAuth = (): void => {
      if (environmentVariables.MOCK_AUTH === true) {
        Cookie.set('_auth_token', 'mockbearertoken123xyz', {
          secure: window.location.protocol === 'https:',
        });
      }
    };

    const setupServiceWorker = async (): Promise<void> => {
      const worker = configureWorker(environmentVariables);
      await worker?.start({
        serviceWorker: {
          url: '/home/mockServiceWorker.js',
        },
      });
      setServiceWorkerReady(true);
    };

    if (mocksEnabled) {
      handleMockAuth();
      setupServiceWorker();
    }
  }, [environmentVariables, mocksEnabled]);

  if (mocksEnabled) {
    return serviceWorkerReady ? <>{children}</> : <>Loading...</>;
  }

  return <>{children}</>;
};

export default MockHandler;
